import {Navigate, Outlet} from "react-router-dom";

const PrivateRoutes = ({isAuthenticated}) => {
    return (
        isAuthenticated ? <Outlet /> : <Navigate to="/admin" replace />
    );
}

export default PrivateRoutes;
